import { Check, Building2 } from "lucide-react";
import { INCLUDED, COMMUNITY_PROVIDES } from "../../data/experiences";
import { Reveal, Eyebrow } from "./Reveal";

export default function WhatsIncluded() {
  return (
    <section id="whats-included" className="py-24 md:py-32 bg-cream">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="max-w-3xl mb-14 md:mb-16">
          <Reveal>
            <Eyebrow>What&rsquo;s Included</Eyebrow>
            <h2 className="mt-5 font-poppins font-bold text-charcoal text-4xl md:text-5xl lg:text-6xl leading-tight tracking-tight">
              Everything is thoughtfully handled.
            </h2>
          </Reveal>
        </div>

        <div className="grid lg:grid-cols-12 gap-8">
          <Reveal className="lg:col-span-8">
            <div className="rounded-[2rem] bg-white border border-border p-8 md:p-10 h-full">
              <ul className="grid sm:grid-cols-2 gap-x-8 gap-y-5">
                {INCLUDED.map((item, i) => (
                  <li key={i} data-testid={`included-${i}`} className="flex items-start gap-3">
                    <span className="mt-0.5 h-6 w-6 shrink-0 rounded-full bg-coral/15 grid place-items-center">
                      <Check size={15} className="text-coral" strokeWidth={2.5} />
                    </span>
                    <span className="text-charcoal/80 leading-relaxed">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>

          <Reveal delay={0.1} className="lg:col-span-4">
            <div className="rounded-[2rem] bg-plum text-cream p-8 md:p-10 h-full">
              <div className="h-12 w-12 rounded-2xl bg-cream/10 grid place-items-center mb-5">
                <Building2 size={24} className="text-marigold" />
              </div>
              <h3 className="font-poppins font-bold text-2xl">What the community provides</h3>
              <ul className="mt-6 space-y-4">
                {COMMUNITY_PROVIDES.map((item, i) => (
                  <li key={i} className="flex items-start gap-3 text-cream/80 leading-relaxed">
                    <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-marigold" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
